import styled from "styled-components";

export const ImageDetailsWrapper = styled.div`
`;